import React, { useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import LazyLoad from 'react-lazyload';

import intersectionObserverPresent from '../../utils/intersectionObserverPresent';
import SynchronousVideo from './SynchronousVideo';
import replayIcon from '../../../../public/ic-replay.svg';
import './SynchronousVideos.module.css';
import { Grid, Cell } from '../../components/atoms/Grid';

const SynchronousVideos = ({ videos, t }) => {
  const [videoPlayers, setVideoPlayers] = useState([]);
  const videoContainer = useRef();

  const attachVideoPlayer = player => {
    setVideoPlayers(prevPlayers => [...prevPlayers, player]);
  };

  const playVideos = () => {
    videoPlayers.forEach(player => player());
  };

  useEffect(
    () => {
      if (
        videoPlayers.length === videos.length &&
        intersectionObserverPresent
      ) {
        const fire = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
              playVideos();
              observer.unobserve(entry.target);
            }
          });
        };
        const io = new IntersectionObserver(fire, { threshold: 0.8 });
        io.observe(videoContainer.current);
        return () => {
          io.unobserve(videoContainer.current);
        };
      }
    },
    [videoPlayers]
  );

  return (
    <LazyLoad offset={100}>
      <div styleName="container" ref={videoContainer}>
        <Grid direction="x" gutters={'margin'}>
          {videos.map((video, index) => (
            <Cell
              mediumSize={24 / videos.length}
              smallSize={videos.length === 4 ? 12 : 24 / videos.length}
              key={index}
            >
              <SynchronousVideo
                {...video}
                attachVideoPlayer={attachVideoPlayer}
              />
            </Cell>
          ))}
        </Grid>
        <button styleName="play-button" onClick={playVideos}>
          <img
            styleName="play-icon"
            src={replayIcon}
            alt=""
            role="presentation"
          />
          {t('Replay Videos')}
        </button>
      </div>
    </LazyLoad>
  );
};

export default withTranslation()(SynchronousVideos);
